export class Upsell {
  public name: string;

  public constructor(name: string) {
    this.name = name;
  }
}
